import { type UseQueryResult } from '@tanstack/react-query'
import { useCountries as useCountriesQuery, useCountriesQueryOptions } from '../generated'

const popularCountriesMap: Record<string, string[]> = {
  NL: ['NL', 'DE', 'BE', 'GB', 'FR'],
}

export type Country = {
  country: string
  isPopular?: boolean
  ordering: number
}

export type UseCountriesReturnType = {
  countries?: Country[]
  default: string
}

export function useCountries(
  originCountryCode: string,
  ...[options]: Parameters<typeof useCountriesQuery<UseCountriesReturnType, string>>
): UseQueryResult<UseCountriesReturnType | undefined, string> {
  return useCountriesQuery({
    query: {
      ...useCountriesQueryOptions(options),
      select: (data) => ({
        ...data,
        countries: data?.countries?.map((country) => {
          const popularCountries = popularCountriesMap[originCountryCode.toUpperCase()] ?? []
          const index = popularCountries.findIndex((c) => c === country)
          const isPopular = index > -1

          return { country, isPopular, ordering: isPopular ? index : popularCountries.length }
        }, []),
      }),
    },
  })
}
